<div class="bc-container tor1">
  <div class="bc-row tor2">
    <p class="log">
      Exit of the experience...
    </p>
    <bc-loader speedLoader="1.5" sizeLoader="lg"></bc-loader>
  </div>
</div>
